import { render, staticRenderFns } from "./numberformat.vue?vue&type=template&id=29f56899&"
import script from "./numberformat.vue?vue&type=script&lang=js&"
export * from "./numberformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29f56899')) {
      api.createRecord('29f56899', component.options)
    } else {
      api.reload('29f56899', component.options)
    }
    module.hot.accept("./numberformat.vue?vue&type=template&id=29f56899&", function () {
      api.rerender('29f56899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BQYjMwGoUhB9/JS/numberformat.vue"
export default component.exports